import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import Summarization from "./Summarization";
import useAppDispatch from "hooks/useAppDispatch";
import { reset } from "features/pictureSearch/pictureSearchSlice";
import { isValidDateString } from "utilities/DateFormatter/validate";

const PictureSummarizationPage: React.FC = () => {
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const location = useLocation();
  const dispatch = useAppDispatch();
  const resetSearchFilter = useCallback(() => {
    dispatch(reset());
  }, [dispatch]);

  useEffect(() => {
    document.addEventListener("back", resetSearchFilter);

    return () => {
      document.removeEventListener("back", resetSearchFilter);
    };
  }, [resetSearchFilter]);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const paramDate = urlParams.get("date");
    let localDate: Date;

    if (paramDate && isValidDateString(paramDate)) {
      const [year, month, day] = paramDate.split("-").map(Number);
      localDate = new Date(year, month - 1, day);
    } else {
      localDate = new Date();
    }

    const startOfDay = new Date(localDate);
    startOfDay.setHours(0, 0, 0, 0);
    setStartDate(startOfDay.toISOString());

    const endOfDay = new Date(localDate);
    endOfDay.setHours(23, 59, 59, 999);
    setEndDate(endOfDay.toISOString());
  }, [location.search]);

  return (
    <section className="h-full flex flex-col space-y-3 lg:space-y-5">
      <div className="flex-1">
        <Summarization startDate={startDate} endDate={endDate} />
      </div>
    </section>
  );
};

export default PictureSummarizationPage;
